import * as Types from "Types";
import { XSSearch as actions } from "actions";
import { XSSearchStatuses as statuses } from "enumerations";

const initialState = {
   status: statuses.idle,
};

function reduxXSSearch(state = initialState, { type, payload }: Types.Reducer): typeof initialState {
   switch (type) {
      case actions.opening:
         return {
            status: statuses.openInit,
         };
      case actions.opened:
         return {
            status: statuses.input,
         };
      case actions.closing:
         return {
            status: statuses.closeInit,
         };
      case actions.closed:
         return {
            status: statuses.idle,
         };
      default:
         return state;
   }
}

export const StateType = typeof initialState;
export { statuses };
export { actions };
export { reduxXSSearch };
